import { combineEpics } from 'redux-observable';
import { fetchAllSlimAssetsEpic } from './fetch-all-slim-assets.epic';

export const combinedSlimAssetsEpics = combineEpics(fetchAllSlimAssetsEpic);
